module.exports = __webpack_public_path__ + "img/ic_folder-manage_option.30b2ab84.svg";